<!--  -->
<template>
  <div class="page">
    <div class="box course">
      <div class="title">购买课程<span>*</span></div>
      <div class="add-course" v-if="!buyProductList.length" @click="changeCourse">
        <span>请选择课程</span
        ><img
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bilibiliShipments/arrow.png"
          alt=""
        />
      </div>
      <div
        class="course-list"
        v-else
        @click="changeCourse"
        v-for="(item, k) in buyProductList"
        :key="k"
      >
        <div class="name">{{ item.name }}</div>
        <div class="sku">
          <span>{{ item.specJson }}</span>
          <img
            v-if="!disbaled"
            src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bilibiliShipments/arrow.png"
          />
        </div>
      </div>
    </div>
    <div class="box order">
      <div class="title">订单信息</div>
      <div class="label">
        <div class="input">
          <span>下单UID<i>*</i></span>
          <input
            @input="orderUidOnchange"
            v-model="orderUid"
            type="tel"
            :readonly="!!disbaled"
            placeholder="请输入下单UID"
          />
        </div>
        <p>查询入口：打开哔哩哔哩-我的-设置-账号</p>
      </div>
      <div class="label">
        <div class="input">
          <span>订单号<i>*</i></span>
          <input
            @input="orderIdOnchange"
            v-model="orderId"
            :readonly="!!disbaled"
            type="tel"
            placeholder="请输入订单号"
          />
        </div>
        <p>查询入口：打开哔哩哔哩-首页-右上角-哔哩哔哩课堂-课程购买成功</p>
      </div>
    </div>
    <div class="box other">
      <div class="title">其他信息</div>
      <div class="label">
        <div class="input">
          <span>微信名<i>*</i></span>
          <input
            v-model="wxUserName"
            type="text"
            :readonly="!!disbaled"
            @keyup="wxUserName = wxUserName.slice(0, 20)"
            placeholder="请输入进群的微信名"
          />
        </div>
      </div>
    </div>
    <div class="box addres" v-if="!iqhId">
      <div class="title">收货信息</div>
      <p>若您已在B站填写收货地址，则无需再次填写。若需要修改，请在此处填写收货信息</p>
      <div class="label">
        <div class="input">
          <span>收件人</span>
          <input
            v-model="consignee"
            type="text"
            @keyup="consignee = consignee.slice(0, 20)"
            placeholder="请填写收件人姓名"
          />
        </div>
      </div>
      <div class="label">
        <div class="input">
          <span>手机号</span>
          <input
            v-model="phone"
            type="tel"
            @keyup="phone = phone.slice(0, 11)"
            placeholder="请填写收件人手机号"
          />
        </div>
      </div>
      <div class="label">
        <div class="input">
          <span>所在地区</span>
          <div class="area" :class="{ active: local }" @click="showArea = true">
            <p>{{ local || '请选择省市区' }}</p>
          </div>
          <div v-if="local" class="delete" @click="clear">
            <img
              src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/vipProduct/delete.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="label">
        <div class="input">
          <span>详细地址</span>
          <textarea
            v-model="addressDetail"
            type="text"
            @keyup="addressDetail = addressDetail.slice(0, 200)"
            placeholder="请填写详细地址"
          />
        </div>
      </div>
    </div>
    <div
      class="foot"
      :class="{ static: keybord, submit: !keybord }"
      @click="submit"
      v-if="!disbaled"
    >
      <div>提交</div>
    </div>
    <selectCourse ref="sku" :productList="productList" @chooseProductList="chooseProductList" />
    <courseSuccess ref="success" />
    <van-popup v-model="showArea" position="bottom">
      <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import {
  reqOnlineProduct,
  reqBiliOrderAdd,
  reqBiliOrderDetail,
  reqBiliOrderEdit,
} from '@/api/personal/index';
import { reqOrderProductInfo } from '@/api/pay/index';
import selectCourse from './components/selectCourse.vue';
import courseSuccess from './components/courseSuccess.vue';
import { areaList } from '@vant/area-data';

export default {
  components: {
    selectCourse,
    courseSuccess,
  },
  data() {
    return {
      productList: [],
      buyProductList: [],
      orderUid: '',
      orderId: '',
      wxUserName: '',
      consignee: '',
      phone: '',
      local: '',
      province: '',
      city: '',
      area: '',
      addressDetail: '',
      showArea: false,
      areaList,
      iqhId: this.$route.query.iqhId,
      disbaled: Number(this.$route.query.disbaled),
      pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, // 正则验证手机号
      keybord: false,
      point: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    orderIdOnchange(event){
      if (typeof event === 'string') {
        event = { target: { value: event } };
      }
      const regex = /\D/g; // 匹配非数字字符
      const input = event.target.value;
      event.target.value = input.replace(regex, '');
      this.orderId = event.target.value.slice(0, 17);
    },
    orderUidOnchange(event){
      if (typeof event === 'string') {
        event = { target: { value: event } };
      }
      const regex = /\D/g; // 匹配非数字字符
      const input = event.target.value;
      event.target.value = input.replace(regex, '');
      this.orderUid = event.target.value.slice(0, 20);
    },
    chooseProductList(data) {
      data.forEach((ele) => {
        const temp = ele.productSkuRespVOList.find(
          (child) => child.productSkuId === ele.productSkuId,
        )?.specJson;
        Object.assign(ele, {
          specJson: JSON.parse(temp)
            ?.map((item) => item.value)
            ?.toString(),
        });
      });
      this.$refs.sku.show = false;
      this.buyProductList = data;
    },
    changeCourse() {
      if (this.disbaled) return;
      this.$refs.sku.show = true;
      this.isEcho();
    },
    isEcho() {
      if (this.buyProductList.length) {
        this.productList.forEach((ele) => {
          const res = this.buyProductList.find((child) => child.id === ele.id);
          Object.assign(ele, { checked: !!res, productSkuId: res?.productSkuId });
        });
      }
    },
    isNumeric(str) {
      return /^\d+$/.test(str);
    },
    // 省市区确认
    onConfirm(values) {
      this.province = values[0]?.name;
      this.city = values[1]?.name;
      this.area = values[2]?.name;
      this.local = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(' ');
      this.showArea = false;
    },
    // 提交
    async submit() {
      const {
        orderUid,
        orderId,
        wxUserName,
        consignee,
        phone,
        addressDetail,
        province,
        area,
        city,
        local,
        buyProductList,
        iqhId,
      } = this;
      const arr = [consignee, phone, local, addressDetail];
      const temp = arr.filter((ele) => {
        return ele;
      });
      if (!this.buyProductList.length) {
        this.$toast('请选择购买课程');
        return;
      }
      if (!this.orderUid) {
        this.$toast('请填写下单UID');
        return;
      }
      if (!this.orderId) {
        this.$toast('请输入订单号');
        return;
      }
      if (this.orderId && this.orderId.length !== 17) {
        this.$toast('订单号格式错误，请输入正确的订单号');
        return;
      }
      if (!this.isNumeric(this.orderUid)) {
        this.$toast('下单UID只能输入数字');
        return;
      }
      if (!this.wxUserName) {
        this.$toast('请填写微信名');
        return;
      }
      if (temp.length > 0 && temp.length < 4) {
        if (!consignee) {
          this.$toast('请填写收件人姓名');
          return;
        }
        if (!phone) {
          this.$toast('请填写收货手机号');
          return;
        }
        if (!local) {
          this.$toast('请填写所在地区');
          return;
        }
        if (!addressDetail) {
          this.$toast('请填写详细地址');
          return;
        }
        return;
      }
      if (this.phone && !this.pattern.test(this.phone)) {
        this.$toast('手机号格式错误，请输入正确的手机号');
        return;
      }

      let params = {
        bilibiliUserId: orderUid,
        buyProductList: buyProductList.map((ele) => {
          return {
            productId: ele.id,
            productSkuId: ele.productSkuId,
          };
        }),
        consignee: consignee || null,
        bilibiliOrderNo: orderId,
        phone: phone || null,
        province,
        city,
        area,
        addressDetail,
        wxUserName,
      };
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      if (this.point) return;
      this.point = true;
      if (!iqhId) {
        const { code, msg } = await reqBiliOrderAdd(params);
        this.$toast(code === 0 ? '操作成功' : msg);
        if (code === 0) {
          this.$refs.success.show = true;
        }
      } else {
        params.id = iqhId;
        const { code, msg } = await reqBiliOrderEdit(params);
        this.$toast(code === 0 ? '提交成功' : msg);
        if (code === 0) {
          wx.miniProgram.navigateBack();
          this.$toast.clear();
        }
      }
      this.point = false;
    },
    // 查课程
    async getCourse() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const { data } = await reqOnlineProduct();
      this.getCourseDetail(data);
    },
    async getCourseDetail(ids) {
      if (ids?.length) {
        const { data } = await reqOrderProductInfo(
          ids.map((ele) => {
            return {
              productId: ele,
            };
          }),
        );
        data?.forEach((item, i) => {
          Object.assign(item, {
            setId: i + 1,
            productSkuRespVOList: item.productSkuRespVOList.filter((ele) => ele.isShow),
          });
        });
        this.productList = data;
      }

      if (this.iqhId) {
        this.getOrderDetail();
      } else {
        this.$toast.clear();
      }
    },
    // 订单信息
    async getOrderDetail() {
      const { data } = await reqBiliOrderDetail(this.iqhId);
      const { bilibiliOrderNo, bilibiliUserId, wxUserName, orderProductRespList } = data;
      this.orderId = bilibiliOrderNo;
      this.orderUid = bilibiliUserId;
      this.wxUserName = wxUserName;
      this.buyProductList = orderProductRespList.map((ele) => {
        return {
          id: ele.productId,
          name: ele.productName,
          productSkuId: ele.productSkuId,
          specJson: ele.skuName || '单品',
        };
      });
      this.$toast.clear();
    },
    clear() {
      this.local = '';
      this.province = '';
      this.city = '';
      this.area = '';
    },
  },
  created() {},
  mounted() {
    this.getCourse();
    if (!this.iqhId) {
      document.title = '填写订单信息';
    } else if (this.iqhId && this.disbaled) {
      document.title = '订单信息';
    } else {
      document.title = '修改订单信息';
    }
    window.addEventListener('focusin', () => {
      this.keybord = true;
    });
    window.addEventListener('focusout', () => {
      this.keybord = false;
    });

    const innerHeight = window.innerHeight;
    window.addEventListener('resize', () => {
      const newInnerHeight = window.innerHeight;
      if (innerHeight > newInnerHeight) {
        this.keybord = true;
      } else {
        // 键盘收起事件处理
        this.keybord = false;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  padding: 36px;
  padding-bottom: 170px;
  background: #f7f8fc;
  .title {
    position: relative;
    padding-left: 29px;
    color: #333;
    font-weight: 500;
    font-size: 33px;
    line-height: 45px;
    span {
      position: relative;
      top: 4px;
      padding-left: 2px;
      color: #ff3938;
    }
  }
  .title::before {
    position: absolute;
    top: 8px;
    left: 0;
    display: block;
    width: 7px;
    height: 29px;
    background: #ff7f41;
    content: '';
  }
  .label:last-child {
    padding-bottom: 0;
  }
  .label {
    padding-bottom: 36px;
    padding-left: 29px;
    .input {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
        i {
          position: relative;
          top: 4px;
          padding-left: 2px;
          color: #ff3938;
        }
      }
      .delete {
        position: absolute;
        right: 20px;
        width: 50px;
        height: 50px;
        font-size: 30px;
        line-height: 50px;
        text-align: center;
        // background: rgba(0, 0, 0, 0.05);
        border-radius: 50%;
        img {
          width: 29px;
          height: 29px;
        }
      }
      textarea {
        height: 140px !important;
        padding-top: 20px;
        line-height: 34px;
      }
      .area {
        line-height: 87px;
        p {
          margin: 0;
          line-height: 87px;
        }
      }
      .area.active {
        p {
          width: 380px;
          overflow: hidden;
          color: #333;
          font-weight: 500;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .area,
      input,
      textarea {
        box-sizing: border-box;
        width: 475px;
        height: 87px;
        padding-left: 22px;
        color: #333;
        font-weight: 500;
        font-size: 25px;
        background: #f5f6f7;
        border: none;
        border-radius: 14px;
      }
      .area,
      input::placeholder,
      textarea::placeholder {
        color: #999;
        font-weight: 400;
      }
    }
    p {
      margin-top: 14px;
      color: #999;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
    }
  }
  .box {
    box-sizing: border-box;
    width: 678px;
    margin: 0 auto 22px;
    padding: 33px 29px 0 0;
    background: #fff;
    border-radius: 14px;
  }
  .course {
    .title {
      padding-bottom: 36px;
    }
    .add-course {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 36px;
      padding-left: 29px;
      span {
        color: #999;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }
      img {
        width: 14px;
        height: 25px;
      }
    }
    .course-list {
      padding-bottom: 36px;
      padding-left: 29px;
      .name {
        color: #333;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }
      .sku {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 14px;
        span {
          display: inline-block;
          margin-right: 14px;
          padding: 2px 10px;
          color: #999;
          font-weight: 400;
          font-size: 22px;
          line-height: 38px;
          text-align: center;
          background: #f7f7f7;
          border-radius: 7px;
        }
        img {
          width: 14px;
          height: 25px;
        }
      }
    }
  }
  .order {
    padding-bottom: 36px;
    .title {
      margin-bottom: 22px;
    }
  }
  .other {
    padding-bottom: 36px;
    .title {
      margin-bottom: 22px;
    }
  }
  .addres {
    > p {
      padding: 18px 0 22px 29px;
      color: #999;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
    }
    .label {
      padding-bottom: 22px;
    }
  }
  .foot {
    width: 100%;
    height: 167px;
    background: #fff;
    box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);
    div {
      width: 678px;
      height: 80px;
      margin: 22px auto 0;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
    }
  }
  .static {
    position: relative;
  }
  .submit {
    position: fixed;
    bottom: 0;
    left: 0;
  }
}
</style>
